import * as React from "react";

const IconPdpListButtonInactive: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="currentColor"><g fill="none" fillRule="evenodd"><rect width="31" height="31" x=".5" y=".5" fill="#FFF" stroke="#D93D04"/><polygon fill="#D93D04" fillRule="nonzero" points="11.5 22 16 19.375 20.5 22 20.5 10 11.5 10"/></g></svg>;
};

export default React.memo(IconPdpListButtonInactive);
